export default __webpack_public_path__ + "static/06_Snake-55a4ed1c34f33b633f7802c7735c3dc1.png";